module.exports = __webpack_public_path__ + "static/media/MIT_Cert.cc4b41d0.png";